import { render, staticRenderFns } from "./MbtiSelection.vue?vue&type=template&id=7127c528&scoped=true"
import script from "./MbtiSelection.vue?vue&type=script&lang=js"
export * from "./MbtiSelection.vue?vue&type=script&lang=js"
import style0 from "./MbtiSelection.vue?vue&type=style&index=0&id=7127c528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7127c528",
  null
  
)

export default component.exports